import React, { useState, useEffect, useLayoutEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { disableAllMenu, isActiveSosongFlowChartModal, isActiveSosongGuideModal } from 'modules/actions/statusMenu';
import { selectCategory } from 'modules/actions/selectCategory';
import { setLevel1List } from 'modules/actions/guideMap';
import { chatList } from 'modules/actions/chat';
import { disabledTabMoveButton, disabledTabMoveInput, fallbackTabMove} from 'helper/index';
import SosongFlowChartGrid from "components/molecules/Modal/SosongFlowChartGrid";
import './style.scss';

const SosongFlowChart = () => {
  const dispatch = useDispatch();
  const clickCategory = useSelector(state => state.setCategory.category);
  const categoryList = useSelector(state => state.guideMapGetList.level1List);
  const btnCategory = useSelector(state => state.setCategory.btnCategory);
  const isOpenGuideModal = useSelector(state => state.isActive.sosongGuideModal);
  const selectSentence = useSelector(state => state.setCategory.btnCategory);

  const closeServiceGuide = () => {
    dispatch(disableAllMenu());
    fallbackTabMove();
  };

  // const [guideTag, setGuideTag] = useState('');
  const categoryNameList = [
    '민사소송절차',
    '형사소송절차',
    '가사소송절차',
    '행정소송절차',
    '특허소송절차',
    '파산회생절차',
    '강제집행절차',
    '신청절차',
    '가족관계등록',
    '공탁절차',
    '소년보호',
    '가정보호',
  ];

 
  const [level1Arr, setLevel1Arr] = useState([]);
  const [level2Arr, setLevel2Arr] = useState([]);
  const [level3Arr, setLevel3Arr] = useState([]);
  const [level4Arr, setLevel4Arr] = useState([]);
  const [level5Arr, setLevel5Arr] = useState([]);
  const [level2_Others, setLevel2_Others] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [level1DetailOpen, setlevel1DetailOpen] = useState(undefined);
  const [level2DetailOpen, setlevel2DetailOpen] = useState(undefined);
  const [level3DetailOpen, setlevel3DetailOpen] = useState(undefined);
  const [level4DetailOpen, setlevel4DetailOpen] = useState(undefined);
  const [level5DetailOpen, setlevel5DetailOpen] = useState(undefined);
  const [allOpenOrClose, setAllOpenOrClose] = useState(true);
  const [openCloseBtnClick, setOpenCloseBtnClick] = useState(true);
  
  const checkBtnClick = () => {
    // console.log("btnCategory[0].level1",btnCategory[0].level1);///
    if(btnCategory) {
      setlevel1DetailOpen(btnCategory[0].level1);
      setlevel2DetailOpen(btnCategory[0].level2);
      setlevel3DetailOpen(btnCategory[0].level3);
      setlevel4DetailOpen(btnCategory[0].level4);
      setlevel5DetailOpen(btnCategory[0].level5);
    }
  }
  const execOnSendMsg = (text,e) => {
    // e.stopPropagation();
    e.preventDefault();
    const paramSet = {
      inType: 'query',
      inStr: text,
      inLabel: text,
      parameters: sessionStorage.getItem('address')
        ? {
            latitude_y: sessionStorage.getItem('latitude_y'),
            longitude_x: sessionStorage.getItem('longitude_x'),
            address: sessionStorage.getItem('address'),
            position_status: 'Y',
          }
        : { latitude_y: '', longitude_x: '', position_status: 'N' },
    };
    dispatch(chatList(paramSet));
    dispatch(disableAllMenu());
  };

  const onKeyPressEvt = (e,text) => {
    if (e.key === 'Enter') {
      execOnSendMsg(text,e);
    }
  };

  useEffect(() => {
    checkBtnClick();
    disabledTabMoveButton(['flowchart_back','flowchart_out','moveButton','ri-close-line flowchart','lastLiBtn','allOpenCloseBtn']);
    disabledTabMoveInput();
  },[]);

  useEffect(() => {
    // checkBtnClick();
    const findIndex = categoryNameList.findIndex(element => element === clickCategory);
    categoryNameList.splice(findIndex, 1);
    categoryNameList.unshift(clickCategory);

    const level1Temp = categoryList.filter(obj => {
      if (obj.level1 !== '0' && obj.level2 === '0') {
        return true;
      }
      return false;
    });
    const level1Others = categoryList.filter(obj => {
      if (obj.level1 !== '0' && obj.level2 !== '0') {
        return true;
      }
      return false;
    });
    const level2Temp = level1Others.filter(obj => {
      if (obj.level1 !== '0' && obj.level2 !== '0' && obj.level3 === '0') {
        return true;
      }
      return false;
    });

    const level2Others = level1Others.filter(obj => {
      if (obj.level1 !== '0' && obj.level2 !== '0' && obj.level3 !== '0') {
        return true;
      }
      return false;
    });

    const level3Temp = level2Others.filter(obj => {
      if (obj.level1 !== '0' && obj.level2 !== '0' && obj.level3 !== '0' && obj.level4 === '0') {
        return true;
      }
      return false;
    });

    const level3Others = level2Others.filter(obj => {
      if (obj.level1 !== '0' && obj.level2 !== '0' && obj.level3 !== '0' && obj.level4 !== '0') {
        return true;
      }
      return false;
    });

    const level4Temp = level3Others.filter(obj => {
      if (obj.level1 !== '0' && obj.level2 !== '0' && obj.level3 !== '0' && obj.level4 !== '0' && obj.level5 === '0') {
        return true;
      }
      return false;
    });

    const level4Others = level3Others.filter(obj => {
      if (obj.level1 !== '0' && obj.level2 !== '0' && obj.level3 !== '0' && obj.level4 !== '0' && obj.level5 !== '0') {
        return true;
      }
      return false;
    });

    setLevel1Arr(level1Temp);
    setLevel2Arr(level2Temp);
    setLevel2_Others(level2Others);
    setLevel3Arr(level3Temp);
    setLevel4Arr(level4Temp);
    setLevel5Arr(level4Others);
    setRefresh(true);
    // setOpenCloseBtnClick(false);

  }, [clickCategory, selectCategory, refresh]);

  const handleSelect = e => {
    // e.preventDefault();
    dispatch(selectCategory(e.target.value));
    // setOpenCloseBtnClick(false);
    setRefresh(false);
    // setRefresh(true);
  };

  const moveCategory = () => {
    resetDetailOpen();
    dispatch(setLevel1List());
    setOpenCloseBtnClick(true);
    setAllOpenOrClose(true);
    setRefresh(false);
  }

  const openClose = () => {
    setOpenCloseBtnClick(true);
    setAllOpenOrClose(!allOpenOrClose);
    setRefresh(false);
  }

  const resetDetailOpen = () => {
    if(level1DetailOpen !== undefined) {
      setlevel1DetailOpen(undefined);
    }
    if(level2DetailOpen !== undefined) {
      setlevel2DetailOpen(undefined);
    }
    if(level3DetailOpen !== undefined) {
      setlevel3DetailOpen(undefined);
    }
    if(level4DetailOpen !== undefined) {
      setlevel4DetailOpen(undefined);
    }
    if(level5DetailOpen !== undefined) {
      setlevel5DetailOpen(undefined);
    }
  }

  const onSosongFlowChart = () => {
    if(!isOpenGuideModal) {
      dispatch(isActiveSosongGuideModal());
    }
    fallbackTabMove();
    dispatch(isActiveSosongFlowChartModal());
  };

  return (
    <div className="flowchart_area" id='flowchart_scroll'>
      <button type='button' className="flowchart_back" onClick={() => onSosongFlowChart()} aria-label='이전'>
        <img src={`${process.env.PUBLIC_URL}/images/svg/additional/flowChartBack.svg`} alt="flowChartBack" style={{ width: '30px', marginRight: '3px' }} />
      </button>
      <button type='button' className='ri-close-line flowchart' onClick={closeServiceGuide} aria-label='닫기'>
      {/* <i className="ri-close-line" onClick={closeServiceGuide} /> */}
      </button>
      <div className="ad_name ad_name_01">
        <img src={`${process.env.PUBLIC_URL}/images/svg/additional/addtionalSosongMain.svg`} alt="" style={{ width: '18px', marginRight: '3px', position: 'relative', top:'2.4px'}} />
        소송절차 안내도
      </div>
      {/* <button type='button' className='sosong_box_button'> */}
      <div className='sosong_select'>
      <select className="sosong_select_box" title="소송절차구분" onChange={handleSelect} value={clickCategory}>
        {categoryNameList.map((name, idx) => {
          return (
            <option value={name} key={`${name}_${idx}`}>
              {name}
            </option>
          );
        })}
      </select>
      <button
          type="button"
          className="moveButton"
          onClick={moveCategory}
        >
          이동
        </button>
        </div>
      <button type='button' 
        className='allOpenCloseBtn' 
        aria-expanded={allOpenOrClose ? 'true' : 'false'}
        onClick={openClose}
      >
      {allOpenOrClose ? '하위메뉴 닫기' : '하위메뉴 펼치기'}
      {allOpenOrClose === true ? <span className='tagButton'>▲</span> : <span className='tagButton'>▼</span>}
      </button>
      {/* {refresh && !openCloseBtnClick && <ul className="tree">
        {level1Arr.map(level1 => {
          if (level1.isContinueNode) {
            return (
              <li>
                <details open={level1.level1 === level1DetailOpen} onToggle={(e) => execOnSendMsg(level1.sentence,e)}>
                <summary><div className='continueTag' onClick={(e) => execOnSendMsg(level1.sentence,e)}>{level1.sentence}</div></summary>
                  <ul>
                    {level2Arr.map(level2 => {
                      if (level1.level1 === level2.level1 && level2.isContinueNode) {
                        return (
                          <li>
                            <details open={level2.level2 === level2DetailOpen}>
                            <summary><div onClick={(e) => execOnSendMsg(level2.sentence,e)}>{level2.sentence}</div></summary>
                              <ul>
                                {level3Arr.map(level3 => {
                                  if (level2.level1 === level3.level1 && level2.level2 === level3.level2 && level3.isContinueNode) {
                                    return (
                                      <li>
                                        <details open={level3.level3 === level3DetailOpen}>
                                        <summary><div onClick={(e) => execOnSendMsg(level3.sentence,e)}>{level3.sentence}</div></summary>
                                          <ul>
                                            {level4Arr.map(level4 => {
                                              if (
                                                level3.level1 === level4.level1 &&
                                                level3.level2 === level4.level2 &&
                                                level3.level3 === level4.level3 &&
                                                level4.isContinueNode
                                              ) {
                                                return (
                                                  <li>
                                                    <details open={level4.level4 === level4DetailOpen}>
                                                    <summary><div onClick={(e) => execOnSendMsg(level4.sentence,e)}>{level4.sentence}</div></summary>
                                                      <ul>
                                                        {level5Arr.map(level5 => {
                                                          if (
                                                            level4.level1 === level5.level1 &&
                                                            level4.level2 === level5.level2 &&
                                                            level4.level3 === level5.level3 &&
                                                            level4.level4 === level5.level4 &&
                                                            !level5.isContinueNode
                                                          ) {
                                                            return <li className='lastLiTag'><button type='button' className='lastLiBtn' onClick={(e) => execOnSendMsg(level5.sentence,e)}>{level5.sentence}</button></li>
                                                          }
                                                          return '';
                                                        })}
                                                      </ul>
                                                    </details>
                                                  </li>
                                                );
                                              }
                                              if (
                                                level3.level1 === level4.level1 &&
                                                level3.level2 === level4.level2 &&
                                                level3.level3 === level4.level3 &&
                                                !level4.isContinueNode
                                              ) {
                                                return <li className='lastLiTag'><button type='button' className='lastLiBtn' onClick={(e) => execOnSendMsg(level4.sentence,e)}>{level4.sentence}</button></li>;
                                              }
                                              return '';
                                            })}
                                          </ul>
                                        </details>
                                      </li>
                                    );
                                  }
                                  if (level2.level1 === level3.level1 && level2.level2 === level3.level2 && !level3.isContinueNode) {
                                    return <li className='lastLiTag'><button type='button' className='lastLiBtn' onClick={(e) => execOnSendMsg(level3.sentence,e)}>{level3.sentence}</button></li>;
                                  }
                                  return '';
                                })}
                              </ul>
                            </details>
                          </li>
                        );
                      }
                      if (level1.level1 === level2.level1 && !level2.isContinueNode) {
                        return <li className='lastLiTag' style={{textIndent : '-0.7em', marginTop: '3px', marginBottom: '5px'}}><button type='button' className='lastLiBtn' onClick={(e) => execOnSendMsg(level2.sentence,e)}>{level2.sentence}</button></li>;
                      }
                      return '';
                    })}
                  </ul>
                </details>
              </li>
            );
          }
          return (
            <li>
              <ul>
              <li className='lastLiTag'><button type='button' className='lastLiBtn' onClick={(e) => execOnSendMsg(level1.sentence,e)}>{level1.sentence}</button></li>
              </ul>
            </li>
          );
        })}
      </ul>} 
      {refresh && openCloseBtnClick && <ul className="tree">
        {level1Arr.map(level1 => {
          if (level1.isContinueNode) {
            return (
              <li>
                <details open={allOpenOrClose} onToggle={(e) => console.log("e.key", e.key)}>
                <summary><div className='continueTag' onClick={(e) => execOnSendMsg(level1.sentence,e)}>{level1.sentence}</div></summary>
                  <ul>
                    {level2Arr.map(level2 => {
                      if (level1.level1 === level2.level1 && level2.isContinueNode) {
                        return (
                          <li>
                            <details open={allOpenOrClose}>
                            <summary><div onClick={(e) => execOnSendMsg(level2.sentence,e)}>{level2.sentence}</div></summary>
                              <ul>
                                {level3Arr.map(level3 => {
                                  if (level2.level1 === level3.level1 && level2.level2 === level3.level2 && level3.isContinueNode) {
                                    return (
                                      <li>
                                        <details open={allOpenOrClose}>
                                        <summary><div onClick={(e) => execOnSendMsg(level3.sentence,e)}>{level3.sentence}</div></summary>
                                          <ul>
                                            {level4Arr.map(level4 => {
                                              if (
                                                level3.level1 === level4.level1 &&
                                                level3.level2 === level4.level2 &&
                                                level3.level3 === level4.level3 &&
                                                level4.isContinueNode
                                              ) {
                                                return (
                                                  <li>
                                                    <details open={allOpenOrClose}>
                                                    <summary><div onClick={(e) => execOnSendMsg(level4.sentence,e)}>{level4.sentence}</div></summary>
                                                      <ul>
                                                        {level5Arr.map(level5 => {
                                                          if (
                                                            level4.level1 === level5.level1 &&
                                                            level4.level2 === level5.level2 &&
                                                            level4.level3 === level5.level3 &&
                                                            level4.level4 === level5.level4 &&
                                                            !level5.isContinueNode
                                                          ) {
                                                            return <li className='lastLiTag' onMouseOver={(e) => console.log("여기")}><button type='button' className='lastLiBtn' onClick={(e) => execOnSendMsg(level5.sentence,e)}>{level5.sentence}</button></li>
                                                          }
                                                          return '';
                                                        })}
                                                      </ul>
                                                    </details>
                                                  </li>
                                                );
                                              }
                                              if (
                                                level3.level1 === level4.level1 &&
                                                level3.level2 === level4.level2 &&
                                                level3.level3 === level4.level3 &&
                                                !level4.isContinueNode
                                              ) {
                                                return <li className='lastLiTag'><button type='button' className='lastLiBtn' onClick={(e) => execOnSendMsg(level4.sentence,e)}>{level4.sentence}</button></li>;
                                              }
                                              return '';
                                            })}
                                          </ul>
                                        </details>
                                      </li>
                                    );
                                  }
                                  if (level2.level1 === level3.level1 && level2.level2 === level3.level2 && !level3.isContinueNode) {
                                    return <li className='lastLiTag'><button type='button' className='lastLiBtn' onClick={(e) => execOnSendMsg(level3.sentence,e)}>{level3.sentence}</button></li>;
                                  }
                                  return '';
                                })}
                              </ul>
                            </details>
                          </li>
                        );
                      }
                      if (level1.level1 === level2.level1 && !level2.isContinueNode) {
                        return <li className='lastLiTag' style={{textIndent : '-0.7em', marginTop: '3px', marginBottom: '5px'}}><button type='button' className='lastLiBtn' onClick={(e) => execOnSendMsg(level2.sentence,e)}>{level2.sentence}</button></li>;
                      }
                      return '';
                    })}
                  </ul>
                </details>
              </li>
            );
          }
          return (
            <li>
              <ul>
              <li className='lastLiTag'><button type='button' className='lastLiBtn' onClick={(e) => execOnSendMsg(level1.sentence,e)}>{level1.sentence}</button></li>
              </ul>
            </li>
          );
        })}
      </ul>} */}
       {refresh && !openCloseBtnClick && <SosongFlowChartGrid level1Arr={level1Arr} level1DetailOpen={level1DetailOpen} level2Arr={level2Arr} level2DetailOpen={level2DetailOpen} level3Arr={level3Arr} level3DetailOpen={level3DetailOpen} level4Arr={level4Arr}level4DetailOpen={level4DetailOpen} level5Arr={level5Arr} execOnSendMsg={execOnSendMsg} refresh={refresh} openCloseBtnClick={openCloseBtnClick} allOpenOrClose={allOpenOrClose}/>}
       
      {refresh && openCloseBtnClick && <SosongFlowChartGrid level1Arr={level1Arr} level1DetailOpen={level1DetailOpen} level2Arr={level2Arr} level2DetailOpen={level2DetailOpen} level3Arr={level3Arr} level3DetailOpen={level3DetailOpen} level4Arr={level4Arr}level4DetailOpen={level4DetailOpen} level5Arr={level5Arr} execOnSendMsg={execOnSendMsg} refresh={refresh} openCloseBtnClick={openCloseBtnClick} allOpenOrClose={allOpenOrClose}/>}
    </div>
  );
};

export default SosongFlowChart;
